import {
	errorColor, purple, tertiaryColor, ltGtMediaQuery,
	linkColor, gtSmMediaQuery, colorsNew,
} from 'root/src/client/web/commonStyles'

export default {
	contentContainer: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
	},
	completeDareTitle: {
		fontSize: 18,
		fontWeight: 500,
		letterSpacing: 0.11,
		marginBottom: '32px !important',
		[ltGtMediaQuery]: {
			display: 'none',
		},
	},
	completedDareDescription: {
		margin: [[16, 0]],
		minHeight: 72,
		fontSize: 14,
		[ltGtMediaQuery]: {
			flex: 'initial',
		},
	},
	dareDetailsRoot: {
		padding: [[70, '5%', 0]],
		[ltGtMediaQuery]: {
			backgroundColor: colorsNew.dark2,
			padding: [[0, '5%', 24]],
			boxShadow: '0 1px 5px 0 rgba(0, 0, 0, 0.1), 0 0 4px 0 rgba(0, 0, 0, 0.1)',
			maxHeight: 'initial',
		},
	},
	infiniteStyle: {
		fontSize: 18,
		lineHeight: 0,
		position: 'relative',
		bottom: '-0.05em',
	},
	dareDetailsWrapper: {
		maxWidth: 1110,
		margin: [[0, 'auto']],
	},
	centered: {
		margin: '0 auto',
		maxWidth: 921,
	},
	imageWrapper: {
		maxWidth: 350,
		[ltGtMediaQuery]: {
			display: 'none',
		},
	},
	image: {
		minWidth: 350,
		width: '100%',
		height: '100%',
	},
	brandWrapper: {
		[gtSmMediaQuery]: {
			position: 'absolute',
			width: '50%',
			right: 0,
			top: '28%',
		},
	},
	brandContainer: {
		[gtSmMediaQuery]: {
			width: '50%',
			maxWidth: 350,
			padding: [[0, 0, 0, 10]],
		},
	},
	brand: {
		maxWidth: 160,
		display: 'flex',
	},
	brandLogo: {
		padding: [[10, 0, 0]],
		height: 45,
		minWidth: 95,
		objectFit: 'none',
	},
	completedDareDetailsRoot: {
		padding: [[60, 0, 0, 0]],
		margin: [[0, 'auto']],
		'@media(max-width: 1530px)': {
			width: 921,
		},
		'@media(max-width: 1280px)': {
			width: 850,
		},
		'@media(max-width: 1160px)': {
			width: 650,
		},
		[ltGtMediaQuery]: {
			backgroundColor: colorsNew.dark2,
			boxShadow: '0 1px 5px 0 rgba(0, 0, 0, 0.1), 0 0 4px 0 rgba(0, 0, 0, 0.1)',
			padding: [[0, 0, 24]],
			margin: 0,
			width: 'inherit',
		},
	},
	completedDareDetailsContent: {
		margin: 16,
		maxWidth: 380,
		'@media(max-width: 1530px)': {
			maxWidth: 340,
		},
		'@media(max-width: 1280px)': {
			maxWidth: 300,
		},
		'@media(max-width: 1160px)': {
			maxWidth: 250,
		},
		[ltGtMediaQuery]: {
			maxWidth: 'inherit',
			margin: [[16, 16, 32]],
		},
	},
	dareDetailsContent: {
		position: 'relative',
		margin: [[0, 0, 0, 30]],
		flex: 2,
		[ltGtMediaQuery]: {
			margin: 0,
		},
	},
	dareDetailsDataColumn: {
		maxWidth: '50%',
		[ltGtMediaQuery]: {
			maxWidth: 'inherit',
			padding: [[8, 0, 0]],
		},
	},
	title: {
		'@media(max-width: 1000px)': {
			fontSize: 22,
		},
	},
	description: {
		margin: [[10, 0]],
		minHeight: 35,
		fontSize: 16,
		textOverflow: 'ellipsis',
		overflowX: 'hidden',
		'@media(max-width: 1070px)': {
			fontSize: 15,
		},
		[ltGtMediaQuery]: {
			flex: 'initial',
		},
	},
	buttonTextWrapper: {
		textAlign: 'center',
		marginBottom: 17,
		minHeight: 16,
		color: tertiaryColor,
		fontSize: 14,
		[gtSmMediaQuery]: {
			margin: [[17, 0, 17, 0]],
		},
	},
	actionButtonSet: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		gap: 40,
		marginTop: 0,
	},
	actionButtonContainer: {
		display: 'flex',
		justifyContent: 'center',
		flexDirection: 'column',
		alignItems: 'center',
		maxWidth: 350,
	},
	autoSize: {
		width: 'auto',
		height: 'auto',
	},
	fullSize: {
		width: '100%',
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
	},
	actionButtonsContainer: {
		flex: 0,
		marginTop: 50,
		alignItems: 'flex-end',
		[ltGtMediaQuery]: {
			marginTop: 15,
		},
	},
	adminButtonsWrapper: {
		alignSelf: 'flex-end',
	},
	adminButtonContainer: {
		margin: 10,
		width: 100,
	},
	buttonWrapper: {
		width: '100%',
		height: 46,
	},
	creatorTitle: {
		marginBottom: 0,
		'& div': {
			fontWeight: 'bold',
			fontStyle: 'normal',
			fontStretch: 'normal',
			fontSize: 16,
		},
	},
	detailsContainer: {
		maxHeight: 168,
		marginBottom: 20,
		'@media(max-width: 980px)': {
			marginBottom: 14,
		},
		[ltGtMediaQuery]: {
			maxHeight: 'initial',
		},
	},
	completedDareDetailsContainer: {
		maxHeight: 111,
		[ltGtMediaQuery]: {
			maxHeight: 'initial',
		},
	},
	completedDareDetailsTextContainer: {
		marginTop: 'auto',
		marginBottom: 5,
		fontSize: 14,
		[ltGtMediaQuery]: {
			margin: [[5, 0]],
		},
	},
	detailsTextContainer: {
		marginTop: 'auto',
		marginBottom: 5,
		fontSize: 16,
		[ltGtMediaQuery]: {
			fontSize: 14,
			margin: [[5, 0]],
		},
	},
	creatorDataWrapper: {
		display: 'inline-flex',
		alignItems: 'center',
		cursor: 'pointer',
		'&:hover': {
			color: linkColor,
		},
	},
	creatorImgWrapper: {
		width: 40,
		margin: [[0, 5, 0, 10]],
		'& img': {
			width: '100%',
			borderRadius: 33,
		},
	},
	flexContainer: {
		display: 'flex',
		alignItems: 'center',
	},
	detailsText: {
		color: tertiaryColor,
		'@media(max-width: 980px)': {
			fontSize: 15,
		},
	},
	detailsTextValue: {
		color: 'white',
	},
	shortUrlProject: {
		'&:hover': {
			color: colorsNew.light3,
			'& > svg > path': {
				fill: colorsNew.light3,
			},
		},
	},
	pledgeButton: {
		marginBottom: 65,
	},
	youPledge: {
		marginTop: 7,
		fontSize: 12,
		fontWeight: 'bold',
		'& span': {
			fontWeight: 'normal',
		},
	},
	icons: {
		flex: 0.25,
		display: 'flex',
		gap: 10,
		maxWidth: 156,
		marginLeft: 'auto',
		[ltGtMediaQuery]: {
			margin: [['auto', 0]],
		},
	},
	iconButton: {
		height: 46,
		width: 46,
		minHeight: 46,
		minWidth: 46,
		fontSize: 30,
		padding: 0,
		margin: [[0, 0, 0, 'auto']],
		border: 'none',
		borderRadius: 4,
		cursor: 'pointer',
		backgroundColor: colorsNew.dark2,
		outline: 'none',
		'&:hover': {
			backgroundColor: colorsNew.dark2,
		},
		'@media(max-width: 1100px)': {
			margin: [[0, 0, 0, 10]],
		},
	},
	shareIcon: {
		fontSize: 24,
	},
	favoriteBorder: {
		padding: [[8, 0, 0]],
		'&:hover': {
			fill: purple,
		},
	},
	favorite: {
		padding: [[8, 0, 0]],
		fill: purple,
		'&:hover': {
			fill: 'currentColor',
		},
	},
	countdownContainer: {},
	countdownText: {
		fontWeight: 700,
		display: 'block',
		marginBottom: 15,
	},
	countdownValue: {},
	expired: {
		color: errorColor,
	},
	totalPledge: {
		marginTop: 10,
		smallText: {
			fontSize: 12,
			fontFamily: 'Roboto',
			textTransform: 'none',
		},
		bigText: {
			fontSize: 18,
			textTransform: 'none',
			fontFamily: 'Roboto',
		},
		deliveryDareButton: {
			'& span': {
				height: 24,
			},
			'& button': {
				color: colorsNew.dark2,
				height: 42,
				borderRadius: 50,
				border: `1px solid ${colorsNew.dark2}`,
				background: 'white',
				'& div': {
					display: 'flex',
					flexDirection: 'column',
				},
			},
			'& button:hover': {
				background: 'white',
			},
		},
	},
	sliderAssignees: {
		display: 'flex',
		justifyContent: 'start',
		maxWidth: 'initial',
		[ltGtMediaQuery]: {
			margin: [[20, 0, 0]],
		},
	},
	assigneesWrapper: {
		padding: '5%',
		position: 'relative',
		[ltGtMediaQuery]: {
			padding: 0,
		},
	},
	assigneesSection: {
		backgroundColor: 'transparent',
		maxWidth: 1110,
		margin: [[0, 'auto']],
		'@media(max-width: 1280px)': {
			width: '90vw',
		},
		[ltGtMediaQuery]: {
			width: '100%',
			margin: 0,
			padding: [[32, '5%']],
		},
	},
	completedDareAssigneesSection: {
		backgroundColor: 'transparent',
		width: 1110,
		margin: [[0, 'auto']],
		'@media(max-width: 1530px)': {
			width: 921,
		},
		'@media(max-width: 1280px)': {
			width: 850,
		},
		'@media(max-width: 1160px)': {
			width: 650,
		},
		[ltGtMediaQuery]: {
			margin: 0,
			padding: [[32, '5%']],
		},
	},
	steamerChallenged: {
		fontSize: 18,
		fontWeight: 500,
		[ltGtMediaQuery]: {
			fontSize: 20,
			margin: 0,
		},
	},
	assigneesContainer: {
		// width: 1110,
		// margin: [[0, 'auto']],
	},
	dareCardRoot: {
		minHeight: 416,
		width: 1110,
		borderRadius: 8,
		boxShadow: '0 1px 5px 0 rgba(0, 0, 0, 0.1), 0 0 4px 0 rgba(0, 0, 0, 0.4);',
		background: colorsNew.dark2,
		marginBottom: 27,
		'@media(max-width: 1530px)': {
			width: 921,
			minHeight: 400,
		},
		'@media(max-width: 1280px)': {
			width: 850,
			minHeight: 375,
		},
		'@media(max-width: 1160px)': {
			width: 650,
			minHeight: 350,
		},
		[ltGtMediaQuery]: {
			flexDirection: 'column-reverse',
			height: 'inherit',
			boxShadow: 'none',
			width: 'inherit',
			marginBottom: 'unset',
		},
	},
	player: {
		height: 416,
		'@media(max-width: 1530px)': {
			height: 400,
		},
		'@media(max-width: 1280px)': {
			height: 375,
		},
		'@media(max-width: 1160px)': {
			height: 350,
		},
	},
	completedDareButton: {
		[ltGtMediaQuery]: {
			padding: [[0, 16]],
		},
	},
	completedIcon: {
		[ltGtMediaQuery]: {
			display: 'none',
		},
	},
	textFieldRoot: {
		margin: [[8, 'auto']],
	},
	pendingVideo: {
		paddingTop: 8,
	},
	dareWrapperHeight: {
		height: 46,
	},
	pointer: {
		cursor: 'pointer',
	},
}
